import { render, staticRenderFns } from "./RegistrationStep3.vue?vue&type=template&id=45c81636"
import script from "./RegistrationStep3.vue?vue&type=script&lang=js"
export * from "./RegistrationStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports